import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { isString } from '~/utils';
import { IconFont } from '..';
import { Tooltip, TooltipProps, ButtonSize } from '@fx-ui/fine-design';

export interface InnerTooltip extends Partial<TooltipProps> {
    content: TooltipProps['content'];
}

interface IconButtonProps {
    icon?: React.ReactNode;
    text?: string;
    active?: boolean;
    className?: string;
    size?: ButtonSize;
    style?: CSSProperties;
    ref?: any;
    disabled?: boolean;
    suffix?: React.ReactNode;
    tooltip?: InnerTooltip;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

const IconButton: React.FunctionComponent<IconButtonProps> = (props) => {
    const {
        icon,
        text,
        active,
        size = 'normal',
        style,
        className,
        ref,
        disabled,
        suffix,
        tooltip,
        onClick,
        onMouseEnter,
        onMouseLeave
    } = props;
    const renderIcon = () => {
        if (isString(icon)) return <IconFont type={icon} />;
        return icon;
    };

    const renderButton = () => {
        return (
            <span
                className={classNames('fx-icon-button', className, {
                    active,
                    disabled,
                    'no-icon': !icon,
                    'has-suffix': !!suffix,
                    [`size-${size}`]: size !== 'normal'
                })}
                style={style}
                onClick={!disabled ? onClick : undefined}
                ref={ref}
                onMouseEnter={!disabled ? onMouseEnter : undefined}
                onMouseLeave={!disabled ? onMouseLeave : undefined}
            >
                {renderIcon()} {text && <span className={classNames('text')}>{text}</span>}
                {suffix}
            </span>
        );
    };

    if (tooltip) {
        return (
            <Tooltip placement="bottom" style={{ whiteSpace: 'nowrap' }} {...tooltip}>
                {renderButton()}
            </Tooltip>
        );
    }

    return renderButton();
};

IconButton.displayName = 'IconButton';

export default IconButton;
